import { apiGet, apiPatch } from './client';
import type { CreditRiskType, CreditRiskTypeBatchRequest } from '../types/CreditRiskType';

export function getCreditRiskTypes(): Promise<CreditRiskType[]> {
  return apiGet<CreditRiskType[]>('/api/credit-risk-types');
}

export function saveBatchCreditRiskTypes(
  added: CreditRiskType[],
  modified: CreditRiskType[],
  deletedIds: number[],
): Promise<CreditRiskType[]> {
  return apiPatch<CreditRiskTypeBatchRequest, CreditRiskType[]>(
    '/api/credit-risk-types/batch',
    { added, modified, deleted: deletedIds },
  );
}
